import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'saneNumber' })
export class SaneNumberPipe implements PipeTransform {
  transform(n: number | string, precision: number = 6): string {
    return Number(
      (typeof n === 'string' ? +n : n).toFixed(precision),
    ).toString();
  }
}
